import type { OverdueTasksParams, AllTasksParams } from '../types';

export const ANALYTICS_KEYS = {
  all: (orgId: string) => ['analytics', orgId] as const,
  orgSummary: (orgId: string) => ['analytics', orgId, 'org-summary'] as const,
  taskStatusOverview: (orgId: string) => ['analytics', orgId, 'task-status-overview'] as const,
  overdueTasks: (orgId: string, params?: OverdueTasksParams) =>
    ['analytics', orgId, 'overdue-tasks', params] as const,
  projectHealth: (orgId: string) => ['analytics', orgId, 'project-health'] as const,
  teamWorkload: (orgId: string) => ['analytics', orgId, 'team-workload'] as const,
  taskDistribution: (orgId: string) => ['analytics', orgId, 'task-distribution'] as const,
  timeAnalysis: (orgId: string) => ['analytics', orgId, 'time-analysis'] as const,
  allTasks: (orgId: string, params?: AllTasksParams) =>
    ['analytics', orgId, 'all-tasks', params] as const,
};
